<div class="infos-panel">

  <!-- Banner: citizen-facing indicator -->
  <div class="panel-banner">
    <mat-icon class="banner-icon">visibility</mat-icon>
    <span>{{ 'request_v2.workspace.banner.citizen' | translate }}</span>
  </div>

  <app-bciti-tabs [badges]="[false, hasUnreadMessages]" (click)="detectActiveTab()">

    <app-bciti-tab [title]="'request_v2.workspace.tabs.infos' | translate">
      <app-request-info
        [request]="request"
        [canEdit]="canEdit"
        (statusUpdated)="onInfoUpdated($event)"
        (departmentUpdated)="onInfoUpdated($event)"
        (subCategoryUpdated)="onInfoUpdated($event)"
        (tagsUpdated)="onInfoUpdated($event)"
        (descriptionUpdated)="onInfoUpdated($event)">
        <app-request-description
          [request]="request"
          [canEdit]="canEdit"
          [showDescription]="false">
        </app-request-description>
      </app-request-info>
    </app-bciti-tab>

    <app-bciti-tab [title]="'request_v2.workspace.tabs.messages' | translate">
      <app-request-messages
        [request]="request"
        [canEdit]="canEdit"
        [isPolling]="isPolling"
        (messagesSent)="requestChanged.emit(request)">
      </app-request-messages>
    </app-bciti-tab>

  </app-bciti-tabs>

</div>
